/**
 * usePdmValue — KPI 2 PDM Valeur (Turnover USD)
 * GET /api/v1/market/kpis/pdm-value
 * spec_kpis.md §4
 */
import { useQuery } from '@tanstack/react-query';
import { fetchKpi } from '../../lib/api';
import type { KpiApiResponse, PdmValueData, MarcheQueryParams } from '../../types/marche.types';

export function usePdmValue(
  params?: MarcheQueryParams,
  options?: { enabled?: boolean; includeRef4w?: boolean; includeRefW1?: boolean; includeRefSwly?: boolean },
) {
  const includeRef4w   = options?.includeRef4w   ?? false;
  const includeRefW1   = options?.includeRefW1   ?? false;
  const includeRefSwly = options?.includeRefSwly ?? false;
  const effectiveParams: MarcheQueryParams | undefined =
    includeRef4w || includeRefW1 || includeRefSwly
      ? {
          ...params,
          ...(includeRef4w   ? { include_ref4w:    true } : {}),
          ...(includeRefW1   ? { include_ref_w1:   true } : {}),
          ...(includeRefSwly ? { include_ref_swly: true } : {}),
        }
      : params;
  return useQuery<KpiApiResponse<PdmValueData>>({
    queryKey: ['market', 'pdm-value', params, { includeRef4w, includeRefW1, includeRefSwly }],
    queryFn: () => fetchKpi<PdmValueData>('pdm-value', effectiveParams),
    staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled: options?.enabled ?? true,
  });
}
